export default __webpack_public_path__ + "static/935-435f5915d3d0b50945d184f797c83f38.gif";